import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import StarCardLoading from '../../components/feedback/StarCardLoading';
import { useAppStore } from '../../stores/appStore';
import { useUserStore } from '../../stores/userStore';

const RedirectPage = () => {
  const navigate = useNavigate();
  const appLoading = useAppStore((state) => state.appLoading);
  const userInfo = useUserStore((state) => state.userInfo);

  useEffect(() => {
    if (appLoading) return;

    navigate(userInfo ? '/home' : '/register', { replace: true });
  }, [appLoading, navigate, userInfo]);

  return <StarCardLoading />;
};

export default RedirectPage;
